import { useState, createContext, useContext } from "react";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import About from "@/components/site/About";
import Proof from "@/components/site/Proof";
import Process from "@/components/site/Process";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import ChatbotWidget from "@/components/site/ChatbotWidget";
import BookCallModal from "@/components/site/BookCallModal";
import BookCallCTA from "@/components/site/BookCallCTA";
import Packages from "@/components/site/Packages";
import WhyWebsite from "@/components/site/WhyWebsite";
import Portfolio from "@/components/site/Portfolio";
import LeadMagnet from "@/components/site/LeadMagnet";
import FAQ from "@/components/site/FAQ";
import MobileStickyCTA from "@/components/site/MobileStickyCTA";

export const BookCallContext = createContext({ open: () => {} });
export const useBookCall = () => useContext(BookCallContext);

export default function Landing() {
  const [preselectedService, setPreselectedService] = useState("");
  const [bookOpen, setBookOpen] = useState(false);
  const [bookVenture, setBookVenture] = useState("");

  const handleServiceSelect = (name) => {
    setPreselectedService(name);
    setTimeout(() => setPreselectedService(""), 100);
    setTimeout(() => setPreselectedService(name), 150);
  };

  const openBook = (venture = "") => {
    setBookVenture(venture);
    setBookOpen(true);
  };

  return (
    <BookCallContext.Provider value={{ open: openBook }}>
      <div data-testid="landing-page" className="relative pb-32 md:pb-0">
        <Navbar />
        <main>
          <Hero />
          <Services onSelectService={handleServiceSelect} />
          <WhyWebsite />
          <Packages />
          <Portfolio />
          <About />
          <Proof />
          <Process />
          <BookCallCTA />
          <LeadMagnet />
          <FAQ />
          <Contact preselectedService={preselectedService} />
        </main>
        <Footer />
        <ChatbotWidget onBookCall={() => openBook()} />
        <BookCallModal open={bookOpen} onClose={() => setBookOpen(false)} defaultVenture={bookVenture} />
        <MobileStickyCTA />
      </div>
    </BookCallContext.Provider>
  );
}
